import React, { useState } from 'react';
import { FiPlus, FiX, FiChevronDown, FiChevronUp } from 'react-icons/fi';

const VariantManager = () => {
  const [products] = useState([
    { id: 1, name: 'Eau de Parfum', variants: ['50ml', '100ml', '200ml'] },
    { id: 2, name: 'Body Mist', variants: ['100ml', '250ml'] },
    { id: 3, name: 'Perfume Oil', variants: ['10ml', '30ml'] }
  ]);
  const [expandedProduct, setExpandedProduct] = useState(null);
  const [newVariant, setNewVariant] = useState('');

  const handleAddVariant = (productId) => {
    if (newVariant.trim()) {
      const updatedProducts = products.map(product =>
        product.id === productId
          ? { ...product, variants: [...product.variants, newVariant] }
          : product
      );
      setNewVariant('');
    }
  };

  const handleRemoveVariant = (productId, variant) => {
    const updatedProducts = products.map(product =>
      product.id === productId
        ? { ...product, variants: product.variants.filter(v => v !== variant) }
        : product
    );
  };

  return (
    <div className="bg-white rounded-lg shadow overflow-hidden">
      <div className="px-6 py-4 border-b border-gray-200">
        <h2 className="text-xl font-semibold text-gray-800">Product Variants</h2>
        <p className="text-sm text-gray-500">Manage sizes, colors and other product variations</p>
      </div>
      
      <div className="divide-y divide-gray-200">
        {products.map((product) => (
          <div key={product.id} className="p-6">
            <div 
              className="flex justify-between items-center cursor-pointer"
              onClick={() => setExpandedProduct(expandedProduct === product.id ? null : product.id)}
            >
              <h3 className="font-medium text-gray-900">{product.name}</h3>
              {expandedProduct === product.id ? (
                <FiChevronUp className="text-gray-500" />
              ) : (
                <FiChevronDown className="text-gray-500" />
              )}
            </div>
            
            {expandedProduct === product.id && (
              <div className="mt-4 pl-4">
                <div className="mb-4">
                  <h4 className="text-sm font-medium text-gray-700 mb-2">Current Variants</h4>
                  <div className="flex flex-wrap gap-2">
                    {product.variants.map((variant, index) => (
                      <div key={index} className="inline-flex items-center px-3 py-1 rounded-full bg-gray-100 text-gray-800">
                        {variant}
                        <button 
                          onClick={() => handleRemoveVariant(product.id, variant)}
                          className="ml-2 text-gray-500 hover:text-red-500"
                        >
                          <FiX size={14} />
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
                
                <div className="flex items-center mt-4">
                  <input
                    type="text"
                    value={newVariant}
                    onChange={(e) => setNewVariant(e.target.value)}
                    placeholder="Add new variant (e.g., 50ml)"
                    className="flex-1 px-3 py-2 border border-gray-300 rounded-l-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                  />
                  <button
                    onClick={() => handleAddVariant(product.id)}
                    className="px-4 py-2 bg-indigo-600 text-white rounded-r-md hover:bg-indigo-700"
                  >
                    <FiPlus />
                  </button>
                </div>
                
                <div className="mt-4 p-3 bg-blue-50 rounded-md">
                  <h4 className="text-sm font-medium text-blue-800">Variant Tips</h4>
                  <ul className="mt-1 text-sm text-blue-700 list-disc pl-5">
                    <li>Use consistent naming (e.g., always use "ml" for volumes)</li>
                    <li>Create variants for all available options</li>
                    <li>Keep variant names short but descriptive</li>
                  </ul>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
      
      <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
        <button className="px-4 py-2 bg-white border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50">
          Add New Product with Variants
        </button>
      </div>
    </div>
  );
};

export default VariantManager;